export default "__VITE_ASSET__DIhjT_NZ__"